import { render, staticRenderFns } from "./Buchstabenjagd.vue?vue&type=template&id=670e2ed0"
import script from "./Buchstabenjagd.vue?vue&type=script&lang=ts"
export * from "./Buchstabenjagd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports